<input #staffingGridValue
    [class.control-invalid]="isRequired"
    type="number"
    [name]="gridCell.id"
    [id]="gridCell.id"
    [max]="maxValue"
    [min]="minValue"
    [value]="gridCell.value"
    [disabled]="readOnly"
    (focus)="$event.target.select()"
    (keydown)="onCellKeyDown($event)"
    (focusout)="onFocusOut(staffingGridValue.value)"
    (keyup)="onCellKeyUp(staffingGridValue.value)">
